module.exports = __webpack_public_path__ + "static/img/timeline-circle.b029a9ba.svg";